import CrudTemplate from "../crudTemplate";
import TipoFornecedorService from "../../services/resource/tipoFornecedor";

export default function TipoFornecedorCrud() {
    const service = new TipoFornecedorService();

    const formFields = [
        { name: "id", label: "ID", type: "input", disabled: true, typeText: "number", colSpan: 1 },
        { name: "descricao", label: "Descrição", type: "input", colSpan: 1 },
    ];

    const tableColumns = [
        { key: "descricao", label: "Descrição", bold: true }
    ];

    return <CrudTemplate
        title="Gerenciar Tipos de Fornecedores"
        formFields={formFields}
        tableColumns={tableColumns}
        service={service}
        style={{ width: '85%' }}
        modalHeader="Tipo de Fornecedor"
    />;
}
